import getSSP from '../lib/getServerSideProps';
import PageComponent from '../components/Page';
import DonationForm from '../components/Donate';

const Donate = (props) => {
  return (
    <PageComponent prepend={false} {...props}>
      <section className="pb-5 border-bottom">
        <div className="container pb-5">
          <div className="row">
            <div className="col-lg-5 col-md-8 col-12">
              <DonationForm list_id={props.settings.data.newsletterId} />
            </div>
          </div>
        </div>
      </section>
    </PageComponent>
  );
};

export default Donate;

const _getServerSideProps = getSSP('page');

export async function getServerSideProps({ locale, previewData }) {
  return _getServerSideProps({
    params: { uid: 'donate' },
    locale,
    previewData
  });
}
